import { Map as olMap, View } from 'ol';
import { Group as LayerGroup, Tile as TileLayer } from 'ol/layer';

import { TileWMS, XYZ } from 'ol/source';
import * as olProj from 'ol/proj';

const originMapView = new View({
	center: olProj.transform([128.0292, 36.6332], 'EPSG:4326', 'EPSG:3857'),
	projection: 'EPSG:3857',
	zoom: 7,
	enableRotation: false,
});

const weightedMapView = new View({
	center: olProj.transform([128.0292, 36.6332], 'EPSG:4326', 'EPSG:3857'),
	projection: 'EPSG:3857',
	zoom: 7,
	enableRotation: false,
});

const matchView = {
	sggMap: originMapView,
	emdMap: originMapView,
	weightedMap: weightedMapView,
};

const maps = {
	sggMap: null,
	emdMap: null,
	weightedMap: null,
};

const getAppLayerGroup = () => {
	const appLayerGroup = {
		sggLayers: {
			bgLayer: new TileLayer({
				source: new XYZ({
					title: '브이월드 일반',
					url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
					attributions: '공간정보오픈플랫폼',
				}),
			}),
			vi_sgg: new TileLayer({
				title: '시군구 지역활력지수',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_sgg',
						STYLES: 'vi_sgg_region',
					},
				}),
			}),
		},

		emdLayers: {
			bgLayer: new TileLayer({
				source: new XYZ({
					title: '브이월드 일반',
					url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
					attributions: '공간정보오픈플랫폼',
				}),
			}),
			vi_emd: new TileLayer({
				title: '읍면동 지역활력지수',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_emd',
						STYLES: 'vi_emd_region',
					},
				}),
			}),
			boundary: new TileLayer({
				title: '행정동 시군구 경계',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:bnd_sigungu_sim_202206',
						STYLES: 'vi_sgg_stroke',
					},
				}),
			}),
		},

		weightedLayers: {
			bgLayer: new TileLayer({
				source: new XYZ({
					title: '브이월드 일반',
					url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
					attributions: '공간정보오픈플랫폼',
				}),
			}),
			vi_sgg: new TileLayer({
				title: '시군구 지역활력지수',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_sgg',
						STYLES: 'pinogio:vi_sgg_region',
					},
				}),
			}),
			vi_emd: new TileLayer({
				title: '읍면동 지역활력지수',
				visible: false,
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_emd',
						STYLES: 'pinogio:vi_emd_region',
					},
				}),
			}),
		},
	};
	return appLayerGroup;
};

const getLayersByKey = (key) => {
	const appLayerGroup = {
		sggLayers: {
			bgLayer: new TileLayer({
				source: new XYZ({
					title: '브이월드 일반',
					url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
					attributions: '공간정보오픈플랫폼',
				}),
			}),
			vi_sgg: new TileLayer({
				title: '시군구 지역활력지수',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_sgg',
					},
				}),
			}),
		},

		emdLayers: {
			bgLayer: new TileLayer({
				source: new XYZ({
					title: '브이월드 일반',
					url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
					attributions: '공간정보오픈플랫폼',
				}),
			}),
			vi_emd: new TileLayer({
				title: '읍면동 지역활력지수',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_emd',
						STYLES: 'vi_emd_region',
					},
				}),
			}),
			boundary: new TileLayer({
				title: '행정동 시군구 경계',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:bnd_sigungu_sim_202206',
						STYLES: 'vi_sgg_stroke',
					},
				}),
			}),
		},

		weightedLayers: {
			bgLayer: new TileLayer({
				source: new XYZ({
					title: '브이월드 일반',
					url: 'https://xdworld.vworld.kr/2d/Base/service/{z}/{x}/{y}.png',
					attributions: '공간정보오픈플랫폼',
				}),
			}),
			vi_sgg: new TileLayer({
				title: '시군구 지역활력지수',
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_sgg',
						STYLES: 'pinogio:vi_sgg_region',
					},
				}),
			}),
			vi_emd: new TileLayer({
				title: '읍면동 지역활력지수',
				visible: false,
				source: new TileWMS({
					url: process.env.REACT_APP_GISSERVER_PATH,
					params: {
						VERSION: '1.3.0',
						FORMAT: 'image/png',
						TRANSPARENT: 'true',
						tiled: 'true',
						LAYERS: 'pinogio:vi_emd',
						STYLES: 'pinogio:vi_emd_region',
					},
				}),
			}),
		},
	};
	return appLayerGroup[key];
};

const setClickEvent = (e, viewResolution, targetLayer, setter) => {
	const useLayer = ['시군구 지역활력지수', '읍면동 지역활력지수'];
	Object.keys(targetLayer).forEach((key) => {
		const layer = targetLayer[key];
		const visible = layer.getVisible();
		const titleCert = useLayer.includes(layer.getProperties().title);
		const instance = layer.getSource() instanceof TileWMS;

		if (visible && titleCert && instance) {
			const url = layer
				.getSource()
				.getFeatureInfoUrl(e.coordinate, viewResolution, 'EPSG:3857', {
					INFO_FORMAT: 'application/json',
				});
			if (url) {
				fetch(url)
					.then((res) => res.json())
					.then((json) => {
						const data = json.features[0].properties;
						setter(data);
					});
			}
		}
	});
};

export { getAppLayerGroup, getLayersByKey, matchView, maps, setClickEvent };
